module.exports = __webpack_public_path__ + "img/wb.16f62373.png";